/**
 * The longest workspace name (customer-portal review 2026-09-25 #153). The API refuses a longer one
 * (`apps/api/src/routes/workspace/workspace-name.ts`); the dialogs count down to it.
 */
export const WORKSPACE_NAME_MAXIMUM = 60;

/** Characters as a person counts them (code points), as the API counts them. */
export function nameLengthOf(name: string): number {
  return [...name.trim()].length;
}
